import { FeatureFlag } from '@data-access/system-controls/feature-flags/enums';

type DefaultRoutes = {
  /** The relative URL path used for the route */
  path: string;
  /** THe name to display to the user (usually in the form of a 'Tab' name) */
  name: string;
  /**
   * A role name to restrict route access to, a value of null/undefined means
   * the route should be accessible without a permission check.
   */
  restrictToRole?: string;
  /**
   * A feature flag that must be enabled for the route/tab to be visible. A
   * value of null/undefined means the route is not gated by a feature flag.
   */
  featureFlag?: FeatureFlag;
};

export const DEFAULT_ROUTES: DefaultRoutes[] = [
  {
    name: 'Document Types',
    path: '/admin/configurations/document-types-list',
  },
  {
    name: 'Submission Types',
    path: '/admin/configurations/submission-types-list',
  },
  {
    name: 'Notification',
    path: '/admin/configurations/notifications',
    featureFlag: FeatureFlag.NOTIFICATION_TEMPLATES,
  },
  {
    name: 'System Controls',
    path: '/admin/configurations/system-controls',
    restrictToRole: 'IT Admin',
  },
];
